export default {"src":"/_next/static/media/AsthmaandChronic.23f9fdb8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};